var cov_1hclxkmalt = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/EditableArea/index.ts",
      hash = "4af576ce9e44b0e5b9e9925ae0b7b6f3a0ee295a",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/EditableArea/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 26
        },
        end: {
          line: 10,
          column: 12
        }
      },
      "1": {
        start: {
          line: 12,
          column: 0
        },
        end: {
          line: 12,
          column: 49
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import delay from '../hoc/delay';
import Component from './EditableArea';
import { compose } from '../utils/func';
import inputable from '../Form/inputable';
var EditableArea = (cov_1hclxkmalt.s[0]++, compose(inputable, delay(400))(Component));
cov_1hclxkmalt.s[1]++;
EditableArea.displayName = 'ShineoutEditableArea';
export default EditableArea;